export default function Vision() {
  return (
    <section className="px-4 md:px-6 pb-4 md:pb-6">
      <div className="bg-zinc-900/[0.05] rounded-[32px] p-6 md:p-10 flex flex-col gap-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto space-y-6">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-zinc-900 leading-tight">
            Nossa visão do ensino<br />que se multiplica
          </h2>
          <p className="text-sm md:text-base text-zinc-900/70 leading-7">
            A TLC Tech nasceu para expandir o Reino através do ensino-aprendizagem comunitário
            TLC: Teaching learning community. Não somos uma plataforma de ensino à distância
            tradicional. Somos uma ponte digital para micro-comunidades onde o cuidado mútuo e a
            aprendizagem acontecem no mesmo estilo de vida discipular de Jesus.
          </p>
        </div>

        {/* Three-panel image card */}
        <div className="rounded-2xl overflow-hidden shadow flex flex-col md:flex-row h-auto md:h-[257px]">
          <div className="flex-1 min-h-40 relative bg-zinc-200">
            <img src="/assets/vision-1.png" alt="Community" className="absolute inset-0 w-full h-full object-cover object-bottom" />
          </div>
          <div className="flex-1 min-h-40 relative bg-zinc-200">
            <img src="/assets/vision-2.png" alt="Teaching" className="absolute inset-0 w-full h-full object-cover" />
          </div>
          <div className="flex-1 min-h-40 relative bg-zinc-200">
            <img src="/assets/vision-3.png" alt="Learning" className="absolute inset-0 w-full h-full object-cover object-bottom" />
          </div>
        </div>
      </div>
    </section>
  )
}
